import { memo } from "react";

import { Menu as MenuComp, MenuItem } from "@material-ui/core";
import { MenuProps } from "@material-ui/core/Menu";

interface Props extends MenuProps {
  id: string;
  items: Array<{
    text: string;
    disabled?: boolean;
    onClick?: () => void;
  }>;
}

const Menu = ({ id, items, ...rest }: Props): JSX.Element => (
  <MenuComp
    id={id}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 35,
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...rest}
  >
    {items.map(({ text, disabled, onClick }, idx: number) => (
      // eslint-disable-next-line react/no-array-index-key
      <MenuItem key={`${id}-${idx}`} disabled={disabled} onClick={onClick}>
        {text}
      </MenuItem>
    ))}
  </MenuComp>
);

export default memo(Menu);
